import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, TransactionApi, type TransactionEntity, type TransactionSearchParams } from '@shared/api';

interface UseTransactionsStore {
  loading: boolean;
  data: TransactionEntity[];
  error: string | null;
  getTransactions: (searchParams: TransactionSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTransactionsStore = create<UseTransactionsStore>((set) => ({
  loading: false,
  error: null,
  data: [],

  getTransactions: ApiUtils.wrapperApi(async (searchParams, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await TransactionApi.getTransactions(searchParams, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
